<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0
    };
  },
  created(){
    localStorage.setItem('lang', 'zh');
    this.$i18n.locale = 'zh';
    this.setDocTitle();
    this.getBaseInfo();
  },
  watch: {
    '$route'() {
      this.setDocTitle();
    },
    '$i18n.locale'() {
      this.setDocTitle();
    }
  },
  methods: {
    setDocTitle(){
      document.title = this.$t('app.brand');
    },
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if(!localStorage.getItem('token') && this.$route.path !== '/Login'){
           this.$router.push({path:'/Login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    }
  }
}
</script>

<style>
body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 500px;
  background: linear-gradient(#1d1610, #3b2818) !important;
}
body .van-toast .van-toast__icon {
  font-size: 50px;
}
*, :after, :before {
  box-sizing: border-box;
}
</style>
